import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import IconRaw from "module-common/Icon";

export default class Reply extends Component {
  static propTypes = {
    name: PropTypes.string,
    content: PropTypes.string,
    onRemove: PropTypes.func
  };

  render() {
    const { name, content, onRemove } = this.props;
    return (
      <Wrapper>
        <InnerWrapper>
          <Name>{name}</Name>
          <Content>{content}</Content>
        </InnerWrapper>
        <Icon name="x-button" onClick={onRemove} />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  background-color: ${props => props.theme.moduleBackground};
`;
const InnerWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 6px 20px;
  border-left: 4px solid ${props => props.theme.blueBorder};
  background-color: white;
`;
const Name = styled.div`
  font-weight: bold;
  color: ${props => props.theme.blueButton};
`;
const Content = styled.div`
  color: ${props => props.theme.uiText};
`;
const Icon = styled(IconRaw)`
  margin: 0 8px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/Reply.js